// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

// --- SILENCE PASSIVE EVENT LISTENERS WARNING ---
// This patch must run AFTER imports but BEFORE the app renders.
// It intercepts the browser's "addEventListener" function to silence the Chrome [Violation] warning.
(function () {
  if (typeof EventTarget !== 'undefined') {
    const func = EventTarget.prototype.addEventListener;
    EventTarget.prototype.addEventListener = function (type, fn, capture) {
      this.func = func;
      if (typeof capture !== 'boolean') {
        capture = capture || {};
        if (capture.passive === undefined) {
          capture.passive =
            type === 'touchstart' || type === 'touchmove' || type === 'wheel';
        }
      }
      this.func(type, fn, capture);
    };
  }
})();
// -----------------------------------------------

// We don't need ThemeProvider here because we aren't using a global custom theme.
// MUI components will fall back to their standard default styles automatically.

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);

reportWebVitals();
